import { CloneFormRequest } from 'epic/common-form/CloneFormRequest';
import { ReloadFormRequest } from 'epic/common-form/ReloadFormRequest';
import { EnrichFormRequest } from 'models/forms/EnrichFormRequest';
import type { EssentialFormResult, EssentialInitFormRequest } from 'models/forms/essential';
import { map } from 'rxjs/operators';
import { IHttpClient } from 'utils/http/httpClient.model';

export function essentialFormApiConnector(httpClient: IHttpClient) {
  return {
    initForm(request: EssentialInitFormRequest) {
      return httpClient
        .postJSON<EssentialFormResult>({ url: `api/v2/forms/essential/init`, body: request })
        .pipe(map(({ payload }) => payload));
    },
    enrichForm(request: EnrichFormRequest) {
      return httpClient
        .postJSON<EssentialFormResult>({ url: `api/v2/forms/essential/modify`, body: request })
        .pipe(map(({ payload }) => payload));
    },
    cloneForm(request: CloneFormRequest) {
      return httpClient
        .postJSON<EssentialFormResult>({ url: `api/v2/forms/essential/clone`, body: request })
        .pipe(map(({ payload }) => payload));
    },
    reloadForm(request: ReloadFormRequest) {
      return httpClient
        .postJSON<EssentialFormResult>({ url: `api/v2/forms/essential/reload`, body: request })
        .pipe(map(({ payload }) => payload));
    },
  };
}
